let itm = [
  {
    href: 'https://www.youtube.com/channel/UCmFEaiDaKet-IT1meLrYcVA',
    img: require('./yt.png'),
  },
  {
    href: 'https://www.google.com',
    img: require('./google.png'),
  },
  {
    href: 'https://generatordyplomow.mac.pl/',
    img: require('./gd.png'),
  },
  // {
  //   href: '',
  //   disable: true,
  //   img: require('./media/pdf.png'),
  // },
  {
    href: 'https://www.facebook.com/macedukacja',
    img: require('./fb.png'),
  },
];
export default itm;
